<div class="side-padding sm:px-0">
  <div class="p-5 pb-0 bg-white rounded-10 max-sm:p-3 max-sm:pb-0">
    <app-breadcrumbs *ngIf="!loader"></app-breadcrumbs>

    <nz-skeleton
      *ngIf="loader"
      [nzActive]="true"
      [nzLoading]="true"
      class="pb-4 max-sm:pb-2"
    >
    </nz-skeleton>

    <div
      class="flex items-center w-full gap-5 px-10 text-white bg-top bg-scores h-238 rounded-10 max-sm:rounded-5 max-sm:h-81 max-sm:px-3 max-sm:gap-3"
      *ngIf="!loader"
    >
      <div
        class="w-[150px] h-[150px] p-4 max-sm:p-2 max-sm:w-[57px] max-sm:h-[57px] bg-white rounded-full flex justify-center items-center"
      >
        <img
          alt="competitionLogo"
          class="w-[105px] h-[105px] max-sm:w-[40px] max-sm:h-[40px] object-contain"
          [src]="
            competitionInfo.logo ? competitionInfo.logo : urlIMG + 'default.png'
          "
        />
      </div>
      <div class="font-inter-600">
        <div class="flex items-center">
          <h1 class="mr-2 text-white text-32 max-sm:text-14">
            {{ competitionInfo.name }}
          </h1>
          <!-- TODO: delete favortio -->
          <!-- <img
            alt="favorite"
            class="cursor-pointer max-sm:w-[15px]"
            [src]="
              urlSVG +
              (competitionInfo.favorite ? 'fav-red.svg' : 'fav-outlined.svg')
            "
            (click)="$event.stopPropagation(); favoriteCompetition()"
          /> -->
        </div>

        <span
          class="flex items-center gap-2 text-16 max-sm:text-11"
          *ngIf="competitionInfo.season"
        >
          <img
            alt="calendar"
            class="max-sm:w-[12px]"
            [src]="urlSVG + 'calendar-white.svg'"
          />
          {{ competitionInfo.season }}
        </span>
      </div>
    </div>

    <ng-container *ngIf="!loader">
      <div class="pt-4 max-sm:pt-2"></div>
      <app-tab-bar
        [selectedIndex]="selectedIndex"
        filtersOptions="competition"
        (selectedIndexChange)="menuSelected($event)"
      ></app-tab-bar>
    </ng-container>
  </div>

  <div class="pt-4 max-sm:pt-2" *ngIf="!loader">
    <!-- Match Tab -->
    <ng-container *ngIf="optionsMenuSelected === 0">
      <div class="font-roboto-500 text-18 max-sm:text-14">
        {{ "MatchesToday" | translate }}
      </div>
      <app-today-matches
        [idCompetition]="competitionInfo.idCompetition"
      ></app-today-matches>

      <div class="mt-3 font-roboto-500 text-18 max-sm:text-14">
        {{ "NextMatches" | translate }}
      </div>

      <app-next-matches
        [idCompetition]="competitionInfo.idCompetition"
      ></app-next-matches>
    </ng-container>

    <!-- Next Matches Tab -->
    <ng-container *ngIf="optionsMenuSelected === 1">
      <app-lastes-matches
        *ngIf="optionsMenuSelected === 1"
        [idCompetition]="competitionInfo.idCompetition"
      ></app-lastes-matches>
    </ng-container>

    <!-- STANDINGS Tab -->
    <ng-container *ngIf="optionsMenuSelected === 2">
      <app-standings-football
        *ngIf="sportsServices.getSelectedSport() === 'Futbol'"
        [idCompetition]="competitionInfo.idCompetition"
      ></app-standings-football>
      <app-standings-sports
        *ngIf="sportsServices.getSelectedSport() !== 'Futbol'"
        [idCompetition]="competitionInfo.idCompetition"
      ></app-standings-sports>
    </ng-container>
  </div>
</div>
